export class ApplePayKeyState {}
